module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-raise-the-bar-oudenaarde-nutrition-coach-1.5e63d34d.jpg";